// src/socket.js
import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_API_URL; // Replace with your server URL

// Initialize the socket connection
const socket = io(SOCKET_URL, {
  transports: ["websocket", "polling"], // Ensure proper transport is used
  autoConnect: false, // Prevent auto-connecting on load
});

// eslint-disable-next-line no-unused-vars
let currentUserId = null; // Track the current user ID

// Connect and emit the login event with user _id
export const connectSocket = (userId) => {
  currentUserId = userId; // Store the user ID

  if (!socket.connected) {
    socket.connect();
    console.log("Socket connected");
  }

  // Emit the connectUser event with the user ID after connecting
  socket.on("connect", () => {
    console.log("Socket reconnected");
    socket.emit("connectUser", userId, true);
  });
};

export const disconnectSocket = () => {
  if (socket.connected) {
    socket.disconnect();
    console.log("Socket disconnected");
  }
};

export const getSocket = () => socket;
